// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AutoNumericController from "./auto_numeric_controller";
application.register("auto-numeric", AutoNumericController);

import DragController from "./drag_controller";
application.register("drag", DragController);

import DropzoneController from "./dropzone_controller";
application.register("dropzone", DropzoneController);

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import ImagePreviewController from "./image_preview_controller";
application.register("image-preview", ImagePreviewController);

import PasswordVisibilityController from "./password_visibility_controller";
application.register("password-visibility", PasswordVisibilityController);

import DesktopMenuToggleController from "./desktop_menu_toggle_controller";
application.register("desktop-menu-toggle", DesktopMenuToggleController);

import DatetimeController from "./datetime_controller";
application.register("datetime", DatetimeController);

import BestInPlaceController from "./best_in_place_controller";
application.register("best-in-place", BestInPlaceController);

import ScrollTopProgressController from "./scroll_top_progress_controller";
application.register("scroll-top-progress", ScrollTopProgressController);

import VehicleMakesController from "./vehicle_makes_controller";
application.register("vehicle-makes", VehicleMakesController);
